var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleSel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 0C11.0785 0 11.75 0.671572 11.75 1.5V2.25H12.8895C13.3452 2.25 13.7762 2.45713 14.0608 2.81296L15.1713 4.20105C15.3841 4.467 15.5 4.79745 15.5 5.1381V8.25C15.5 9.07845 14.8285 9.75 14 9.75C14 10.9927 12.9927 12 11.75 12C10.5073 12 9.5 10.9927 9.5 9.75H6.5C6.5 10.9927 5.49264 12 4.25 12C3.00736 12 2 10.9927 2 9.75C1.17157 9.75 0.5 9.07845 0.5 8.25V1.5C0.5 0.671572 1.17157 0 2 0H10.25ZM4.25 9C3.83579 9 3.5 9.33577 3.5 9.75C3.5 10.1642 3.83579 10.5 4.25 10.5C4.66421 10.5 5 10.1642 5 9.75C5 9.33577 4.66421 9 4.25 9ZM11.75 9C11.3358 9 11 9.33577 11 9.75C11 10.1642 11.3358 10.5 11.75 10.5C12.1642 10.5 12.5 10.1642 12.5 9.75C12.5 9.33577 12.1642 9 11.75 9ZM10.25 1.5H2V8.25H2.57292C2.98491 7.78972 3.58363 7.5 4.25 7.5C4.86512 7.5 5.42258 7.74687 5.82875 8.14686L5.92708 8.25H10.0729L10.159 8.15902L10.25 8.07292V1.5ZM12.8895 3.75H11.75V7.5C12.3651 7.5 12.9226 7.74687 13.3287 8.14686L13.4271 8.25H14V5.1381L12.8895 3.75Z",
    fill: "#2C8C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleSel);
export default __webpack_public_path__ + "static/media/vehicle_sel.8014a2f951a6c13cc0eb9c549d7555d3.svg";
export { ForwardRef as ReactComponent };